import { useEffect } from "react";
import { useAtom, useSetAtom } from "jotai";
import { useNavigate } from "react-router-dom";

import { cn } from "shared/lib";
import { accountVar, isAuthenticatedVar } from "@/variables/globalVar";

import { useGetAccount, useGetAuthTest } from "shared/apiHooks";
import { useMediaQuery } from "shared/hooks";

import { ForgotPassword } from "@/components/auth";
import { useAccount, useCaptureEvent, CaptureEventType } from "@/hooks";

export function ForgotPasswordPage() {
  const navigate = useNavigate();

  const [isAuthenticated, setIsAuthenticatedVar] = useAtom(isAuthenticatedVar);
  const setAccountVar = useSetAtom(accountVar);

  const { captureEvent } = useCaptureEvent();

  const md = useMediaQuery({
    query: "(min-width: 768px)",
  });

  const { isError, isSuccess } = useGetAuthTest({ retry: false });

  useEffect(() => {
    if (isSuccess) {
      setIsAuthenticatedVar(true);
    } else if (isError) {
      setIsAuthenticatedVar(false);
    }
  }, [isError, isSuccess]); // eslint-disable-line react-hooks/exhaustive-deps

  const { data: accountResponse } = useGetAccount({
    enabled: isAuthenticated,
    retry: false,
  });

  useEffect(() => {
    if (accountResponse?.data) {
      setAccountVar(accountResponse?.data);
    }
  }, [accountResponse?.data, setAccountVar]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    captureEvent(CaptureEventType.USER_FORGOT_PASSWORD_PAGE_VISITED);
  }, [captureEvent]);

  return (
    <div
      className={cn(
        "flex grow flex-col overflow-y-auto px-5 py-5 md:pt-2",
        !md ? "bg-interfaceBgLightPaper" : "bg-interfaceBgDarkPaper",
      )}
    >
      <div
        className={cn(
          "flex grow flex-col items-center justify-center rounded-xl",
          md ? "bg-interfaceBgLightPaper" : "",
        )}
      >
        <div className="w-full md:max-w-[480px]">
          <ForgotPassword />
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
